export const DebtExemptionTypes = {
  SHOW_APARTMENTS: "SHOW_APARTMENTS",
  SEND_DEBT_EXEMPTION: "SEND_DEBT_EXEMPTION",
  SHOW_EXEMPTION_BY_APARTMENT: "SHOW_EXEMPTION_BY_APARTMENT",
  SEND_DEBT_EXEMPTION_DELETE: "SEND_DEBT_EXEMPTION_DELETE"

};
